import React from 'react';
import { Code, Database, Briefcase, Users } from 'lucide-react';

const WhatYouWillLearn = () => {
  const targetAudience = [
    {
      icon: <Code className="w-12 h-12 text-[#f2055c]" />,
      title: 'Iniciantes absolutos em programação',
      description: 'Você não precisa ter experiência prévia, vamos começar do zero mesmo.'
    },
    {
      icon: <Database className="w-12 h-12 text-[#f2055c]" />,
      title: 'Desenvolvedores de outras linguagens',
      description: 'Se você já programa em outra linguagem, vai aprender a transição para o Java de forma rápida.'
    },
    {
      icon: <Briefcase className="w-12 h-12 text-[#f2055c]" />,
      title: 'Estudantes buscando o primeiro emprego',
      description: 'Aprenda exatamente o que as empresas procuram em um desenvolvedor Java iniciante.'
    }
  ];

  const additionalTargets = [
    'Quer sair do zero e aprender programação do jeito certo',
    'Se sente perdido na área tech e não sabe por onde começar',
    'Busca um plano claro de estudos pra evoluir com foco',
    'Deseja ter confiança em entrevistas técnicas e mandar bem nos desafios',
    'Sonha em conquistar uma vaga bem remunerada como dev Java',
    'Quer dominar Java, Spring Boot e boas práticas pra criar sistemas robustos e ser reconhecido no mercado'
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Para quem é esse evento?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-center">
            Um programa intensivo de uma semana que vai transformar sua compreensão sobre desenvolvimento Java.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {targetAudience.map((item, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300 animate-fadeInUp"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold mb-6 text-center">
            A Java Dev Week também é para você que:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {additionalTargets.map((target, index) => (
              <div 
                key={index}
                className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-sm"
              >
                <Users className="w-6 h-6 text-[#f2055c] flex-shrink-0" />
                <span className="text-gray-700">{target}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouWillLearn;